import { Col, Row, Table } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import styled from 'styled-components'

export const CardRow = styled(Flex)`
  padding: 0 25px 25px 0px;
  gap: 20px;
`
export const HeaderSmallText = styled.h5`
  font-size: 12px;
`
export const NoteDisplay = styled('div')`
  background: rgba(242, 244, 255, 1);
  width: Fixed (1, 050px) px;
  padding: 10px;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 18px;
`
export const TopHeadingTPO = styled(Flex)`
  font-style: normal;
  font-family: 'Plus Jakarta Sans';
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #343e59;
`
export const LeftSectionTPO = styled(Flex)`
  gap: 10px;
  flex-wrap: wrap;
`

export const ColsEnd = styled(Col)`
  display: flex;
  justify-content: flex-end;
`
export const SpaceBetweenRow = styled(Row)`
  // justify-content: space-between;
  margin-top: 10px;
`

export const StyledFilterCol = styled(Col)`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
`

export const StyledFormItem = styled(FormItem)`
  width: 100%;
`
export const BackgroundDiv = styled.div`
  background: rgba(255, 255, 255, 1);
  padding: 30px;
`

export const StyledPrimaryBtn = styled(Button.Primary)`
  background: ${props =>
    props?.disabledStyle
      ? 'rgba(209, 213, 219, 1) !important'
      : 'rgba(37, 99, 235, 1)'};
  color: #ffffff !important;
`

export const StyledActiveBox = styled('div')(({}) => ({
  height: 500,
  maxHeight: 200,
  overflowY: 'scroll',
}))

export const StyledActiveSubBox = styled('div')(
  ({ isOverflow, labelsLength }) => {
    const newHeight = 300 + (labelsLength - 7) * 20
    return { height: isOverflow ? newHeight : 300 }
  }
)
export const StyledScrollBox = styled('div')(({ viewAll }) => {
  return {
    height: viewAll ? 'unset' : '500px',
    maxHeight: viewAll ? 'unset' : '250px',
    overflowY: 'auto',
    paddingRight: '10px',

    /* Customizing the vertical scrollbar */
    '&::-webkit-scrollbar': {
      width: '8px' /* Reduced width of the scrollbar */,
    },

    /* Customizing the thumb (draggable part of the scrollbar) */
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#DBDBDB' /* Color of the thumb */,
      borderRadius: '10px' /* Rounded corners for the thumb */,
    },

    /* Hover effect for the thumb */
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor:
        '#DBDBDB' /* Darker color when hovering over the thumb */,
    },

    /* Customizing the track (background area of the scrollbar) */
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f5f5f5' /* Background color of the scrollbar track */,
      borderRadius: '10px' /* Rounded corners for the scrollbar track */,
    },
  }
})

export const StyledScrollBoxBody = styled('div')(
  ({ isOverflow, labelsLength }) => {
    const newHeight = 300 + (labelsLength - 7) * 20
    return {
      height: isOverflow ? newHeight : 250,
      position: 'relative',
      marginLeft: 50,
    }
  }
)

export const StyledChartSecBox = styled('div')(({ isBackground }) => {
  return {
    height: 50,
    marginTop: -12,
    marginRight: 5,
    marginLeft: 50,
    background: isBackground ? 'unset' : '#FFFFFF',
    position: 'relative',
    zIndex: 1,
  }
})

export const StyledScrollBarButton = styled('button')(
  ({ rotate, width, marginRight, position, top, right }) => {
    return {
      background: '#F6F6F6',
      border: '1px solid #C3C4CC',
      outline: 'none',
      width: width || 20,
      height: 20,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 1,
      paddingRight: 1,
      paddingTop: 0,
      paddingBottom: 0,
      transform: rotate ? `rotate(${rotate}deg)` : 'unset',
      borderRadius: 5,
      marginRight: marginRight,
      position: position,
      top: top,
      right: right,
    }
  }
)

export const StyledSpacer = styled('div')(({ height }) => {
  return {
    width: 20,
    height: height || 10,
    background: '#fff',
  }
})

export const StyledDownArrow = styled('div')(({}) => {
  return {
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '10px solid blue',
  }
})

export const StyledShadowBox = styled('div')(({}) => {
  return {
    boxShadow: '4px 2px 15px 0px #0000001A',
    background: '#FFFFFF',
    borderRadius: '10px',
    padding: 50,
    marginBottom: 40,
  }
})

export const ShadowBoxTitle = styled('div')(({}) => {
  return {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Plus Jakarta Sans',
    marginBottom: 10,
  }
})

export const ShadowBoxSubTitle = styled('div')(({}) => {
  return {
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Plus Jakarta Sans',
    marginBottom: 10,
  }
})

export const CustomLegend = styled('div')(
  ({ color, width, height, borderRadius, marginRight, borderColor }) => {
    return {
      width: width || '17px',
      height: height || '17px',
      backgroundColor: color, // Correct index offset
      marginRight: marginRight || '8px',
      borderRadius: borderRadius || '17px',
      border: `1px solid ${borderColor || 'unset'}`,
    }
  }
)

export const ColSmall = styled('div')(({}) => {
  return {
    width: '35px',
  }
})
export const ColLargeScroll = styled('div')(({ length }) => {
  return {
    maxWidth: 900,
    overflowX: 'scroll',
    '&::-webkit-scrollbar': {
      width: '8px' /* Reduced width of the scrollbar */,
      height: '8px',
    },

    /* Customizing the thumb (draggable part of the scrollbar) */
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#DBDBDB' /* Color of the thumb */,
      borderRadius: '10px' /* Rounded corners for the thumb */,
    },

    /* Hover effect for the thumb */
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor:
        '#DBDBDB' /* Darker color when hovering over the thumb */,
    },

    /* Customizing the track (background area of the scrollbar) */
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f5f5f5' /* Background color of the scrollbar track */,
      borderRadius: '10px' /* Rounded corners for the scrollbar track */,
    },
  }
})

export const ColLarge = styled('div')(({ length }) => ({
  // maxWidth: 900,
  // overflowX: length > 5 ? 'auto' : 'hidden',
  overflowX: 'auto',

  /* Hide scrollbar for Chrome, Safari, and Opera */
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  /* Hide scrollbar for IE, Edge, and Firefox */
  msOverflowStyle: 'none', // IE and Edge
  scrollbarWidth: 'none', // Firefox
}))

export const ColLargeFixed = styled('div')(({ length, isScrollable }) => {
  const newWidth = 900 + (length - 7) * 150
  return {
    width: `calc(${length > 4 ? newWidth + 'px' : '700px'} - 35px)`,
    height: 300,
  }
})
export const PlacementContainer = styled('div')(({}) => {
  return {
    display: 'flex',
    // width: 900,
  }
})

export const CustomLegendLabelRow = styled(Col)(
  ({ weight, textAlign, size, active, width }) => {
    return {
      fontSize: size || 14,
      fontWeight: weight || 500,
      textAlign: textAlign,
      color: active ? '#3249D7' : 'inherit',
      width: width || 'unset',
    }
  }
)

export const StyledViewAllBtn = styled(Button.Secondary)`
  .secondary_icon_container {
    flex-direction: row-reverse;
    gap: 10px;
  }
  .secondary_text_container {
    font-size: 13px;
    font-weight: 500;
    color: #000000;
  }
`
export const ScrollbarTrack = styled.div`
  width: 700px;
  height: 5px;
  background: #efefef;
  position: relative;
  overflow: hidden;
`

export const ScrollbarThumb = styled.div`
  width: 50%;
  height: 100%;
  background: #dbdbdb;
  position: absolute;
  left: ${({ position }) => position}px;
  transition: left 0.3s ease;
`

export const GraphTitle = styled('div')(
  ({ verticalOrientation, mBottom, mLeft, position, bottom }) => {
    return {
      fontWeight: 700,
      color: '#000000',
      fontSize: 12,
      writingMode: verticalOrientation ? 'sideways-lr' : 'unset',
      marginBottom: mBottom,
      marginLeft: mLeft,
      position: position,
      bottom: bottom,
    }
  }
)

export const StyledStatusBox = styled.div`
  border: ${props =>
    props?.active ? `1px solid #3249D7` : '1px solid #c2c2c2'};
  border-radius: 8px;
  padding: 5px 20px;
  width: 100%;
`
export const StyledClearText = styled.div`
  color: ${props => (props?.selected ? '#F6616B' : '#717171')};
  font-weight: 400;
  font-size: 10px;
  padding: 5px 0px;
  text-align: right;
  cursor: ${props => (props?.selected ? 'pointer' : 'default')};
`

export const StyledDynamicText = styled.div`
  color: ${props => (props?.color ? props?.color : '#000000')};
  font-weight: ${props => (props?.weight ? props?.weight : '400')};
  font-size: ${props => (props?.size ? props?.size : '14px')};
  width: ${props => (props?.width ? props?.width : '100%')};
  padding-top: ${props => (props?.pt ? props?.pt : '0px')};
  padding-bottom: ${props => (props?.pb ? props?.pb : '0px')};
  padding-left: ${props => (props?.pl ? props?.pl : '0px')};
  padding-right: ${props => (props?.pr ? props?.pr : '0px')};
  margin-top: ${props => (props?.mt ? props?.mt : '0px')};
  margin-bottom: ${props => (props?.mb ? props?.mb : '0px')};
  margin-left: ${props => (props?.ml ? props?.ml : '0px')};
  margin-right: ${props => (props?.mr ? props?.mr : '0px')};
  text-align: ${props => (props?.align ? props?.align : 'left')};
`

export const StyledDrawer = styled(Drawer)(() => ({
  '.ant-drawer-header': {
    display: 'none',
  },
  '.ant-drawer-content': {
    height: 'auto',
  },
}))

export const StyledPDFTable = styled(Table)(() => ({
  '.ant-table-tbody > tr > td': {
    padding: 8,
    fontSize: 23,
  },
  '.ant-table-thead > tr > th': {
    background: '#EEEEEE',
    fontSize: 25,
    fontWeight: 700,
    color: '#000000',
    padding: 8,
  },
}))

export const Box1 = styled.div`
  width: 700px;
  max-width: 700px;
  overflow-x: scroll;
`
export const Box2 = styled.div`
  width: 2700px;
  height: 500px;
`
